import {MouseEvent} from "react";
import {usePlayerView} from "@/player/PlayerViewHooks.ts";
import OverlayModal from "@/modal/OverlayModal.tsx";
import PlayerViewTransition from "@/player/view/PlayerViewTransition.tsx";

export default function PlayerView() {
    const {display, loading, error} = usePlayerView();

    const handleContextMenu = (event: MouseEvent<HTMLDivElement>) => {
        event.preventDefault();
    };

    return (
        <div className="relative flex h-full flex-col overflow-hidden" onContextMenu={handleContextMenu}>
            <title>{`Spieleransicht | DireDawn`}</title>
            <OverlayModal readOnly={true}/>
            <PlayerViewTransition display={display} loading={loading} error={error}/>
        </div>
    );
}
